module.exports = __webpack_public_path__ + "media/customizations/caldwellcommunities/back-c08c631dbe03aa5672b29912bb006689.jpg";